import { render } from "./sidebar-finish.vue?vue&type=template&id=5f911a96"
import script from "./sidebar-finish.vue?vue&type=script&lang=js"
export * from "./sidebar-finish.vue?vue&type=script&lang=js"
script.render = render

export default script